"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.CalendarThead = exports.CalendarTh = exports.CalendarTbody = exports.CalendarTable = exports.Announcer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _theme = require("@atlaskit/theme");

/* eslint no-confusing-arrow: 0 */
var wrapperBackgroundColor = (0, _theme.themed)({
  light: _theme.colors.N0,
  dark: _theme.colors.N700
});
var getCalendarThColor = (0, _theme.themed)({
  light: _theme.colors.N200,
  dark: _theme.colors.N200
});

var Announcer = _styledComponents.default.div.withConfig({
  displayName: "Calendar__Announcer",
  componentId: "sc-3j1sll-0"
})(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n"]);

exports.Announcer = Announcer;

var CalendarTable = _styledComponents.default.table.withConfig({
  displayName: "Calendar__CalendarTable",
  componentId: "sc-3j1sll-1"
})(["\n  display: inline-block;\n  margin: 0;\n  text-align: center;\n"]);

exports.CalendarTable = CalendarTable;

var CalendarTbody = _styledComponents.default.tbody.withConfig({
  displayName: "Calendar__CalendarTbody",
  componentId: "sc-3j1sll-2"
})(["\n  border: 0;\n"]); // FIXME: first-child
// @atlaskit/css-reset should adjust default behaviours


exports.CalendarTbody = CalendarTbody;
var thSpacing = (0, _styledComponents.css)(["\n  padding: 8px 8px;\n  min-width: 40px;\n  box-sizing: border-box;\n"]);

var CalendarTh = _styledComponents.default.th.withConfig({
  displayName: "Calendar__CalendarTh",
  componentId: "sc-3j1sll-3"
})(["\n  border: 0;\n  color: ", ";\n  font-size: 11px;\n  ", ";\n  text-transform: uppercase;\n  text-align: center;\n\n  &:last-child,\n  &:first-child {\n    ", ";\n  }\n"], getCalendarThColor, thSpacing, thSpacing);

exports.CalendarTh = CalendarTh;

var CalendarThead = _styledComponents.default.thead.withConfig({
  displayName: "Calendar__CalendarThead",
  componentId: "sc-3j1sll-4"
})(["\n  border: 0;\n"]);

exports.CalendarThead = CalendarThead;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Calendar__Wrapper",
  componentId: "sc-3j1sll-5"
})(["\n  background-color: ", ";\n  color: ", ";\n  display: inline-block;\n  padding: 16px;\n  user-select: none;\n  box-sizing: border-box;\n  outline: none;\n"], wrapperBackgroundColor, _theme.colors.text);

exports.Wrapper = Wrapper;